import _ from 'lodash'
import React, { useCallback } from 'react'
import { Box, Grid } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import PawButtton from 'components/Button/PawButtton'
import BigNumber from 'bignumber.js'
import numeral from 'numeral'
import { useFarms, usePriceBnbBusd, usePriceSmoyUsd } from 'state/hooks'
import { FarmWithStakedValue } from 'views/Farms/components/FarmCard/FarmCard'
import { getFarmApr } from 'utils/apr'

const useStyles = makeStyles((theme) => ({
  earnCover: {
    fontFamily: "'Dosis', sans-serif",
    fontWeight: 800,
    backgroundColor: '#FFDFBA',
    position: 'relative',
    zIndex: 11,
    padding: '40px',
    borderRadius: '8px',
    margin: '0 0 40px',
    '& .earnBox': {
      backgroundColor: '#FFFFBA',
      color: '#2B1C2F',
      padding: '16px',
      borderRadius: '8px',
      height: '100%',

      '& h6': {
        fontSize: '36px',
        lineHeight: '48px',
        textAlign: 'center',
        margin: 0,
        fontWeight: 800,
      },
      '& p': {
        fontSize: '18px',
        lineHeight: '24px',
        textAlign: 'center',
        margin: '16px 0 0',
        fontWeight: 800,
      },
      '& img': {
        width: '100%',
        padding: '0 46px',
        margin: '16px 0 0',
      },
      '& .farmItem': {
        padding: '8px',
        backgroundColor: '#fff',
        display: 'flex',
        alignItems: 'center',
        margin: '16px 0 0',
        borderRadius: '8px',
      },
      '& .coin': {
        width: '48px',
        height: '48px',
        margin: 0,
        padding: 0,
      },
      '& .sep': {
        margin: '0 8px',
      },
      '& .apr': {
        margin: '0 0 0 auto',
        fontSize: '18px',
        lineHeight: '24px',
      },
      '& .btnCover': {
        margin: '16px 0 0',
        textAlign: 'center',
      },
    },
  },
  [theme.breakpoints.up('sm')]: {},
}))

const EarnBox = () => {
  const classes = useStyles()
  const farmsLP = useFarms()
  const bnbPrice = usePriceBnbBusd()
  const smoyPrice = usePriceSmoyUsd()

  const activeFarms = farmsLP.filter(
    (farm) => farm.pid !== 0 && farm.multiplier !== '0X' && Number(farm.maxDepositFeeRate) === 0
  )

  const farmAPR = (farm) => {
    if (!farm.apr) return '0.00'
    const apr = new BigNumber(farm.apr).toNumber()
    if (apr < 10) return numeral(apr).format('0,0.00')
    return numeral(apr).format('0,0')
  }

  const farmsList = useCallback(
    (farmsToDisplay) => {
      const smoyPriceUSD = smoyPrice // new BigNumber(farmsLP.find((farm) => farm.pid === PUPPY_POOL_PID)?.tokenPriceVsQuote || 0)
      const farmsToDisplayWithAPR: FarmWithStakedValue[] = _.chain(farmsToDisplay)
        .map((farm) => {
          if (!farm.tokenAmount || !farm.lpTotalInQuoteToken || !farm.lpTotalInQuoteToken) {
            return farm
          }

          let poolLiquidityUsd = new BigNumber(0)
          const lpTotalInQuoteToken = new BigNumber(farm.lpTotalInQuoteToken)
          switch (farm.quoteTokenSymbol) {
            case 'SMOY':
              poolLiquidityUsd = lpTotalInQuoteToken.times(smoyPriceUSD)
              break
            case 'BNB':
              poolLiquidityUsd = lpTotalInQuoteToken.times(bnbPrice)
              break
            default:
              poolLiquidityUsd = lpTotalInQuoteToken
          }

          const apr = getFarmApr(farm.poolWeight, smoyPriceUSD, poolLiquidityUsd)

          return { ...farm, apr }
        })
        .sortBy((i) => {
          return i.multiplier
        })
        .reverse()
        .value()

      return (
        <>
          {farmsToDisplayWithAPR.map((farm) => (
            <Box className="farmItem" key={farm.pid}>
              <img className="coin" src="/images/coins/smoy.png" alt="smoy" />
              <span className="sep">x</span>
              {farm.tokenSymbol === 'BUSD' ? (
                <img className="coin" src="/images/coins/BUSD-black.svg" alt="busd" />
              ) : (
                <img className="coin" src="/images/coins/BNB-black.png" alt="bnb" />
              )}
              <span className="apr">APR {farmAPR(farm)}%</span>
            </Box>
          ))}
        </>
      )
    },
    [smoyPrice, bnbPrice]
  )

  return (
    <Box className={classes.earnCover}>
      <Grid container alignItems="stretch" spacing={2}>
        <Grid item md={4} xs={12}>
          <Box className="earnBox">
            <h6>Pot</h6>
            <p>Coming Soon!</p>
            <img src="/images/coming-soon-2.png" alt="coming soon" />
          </Box>
        </Grid>
        <Grid item md={4} xs={12}>
          <Box className="earnBox">
            <h6>Farm</h6>

            {farmsList(activeFarms)}
            <Box className="btnCover">
              <PawButtton href="/farm" color="yellow">
                More
              </PawButtton>
            </Box>
          </Box>
        </Grid>
        <Grid item md={4} xs={12}>
          <Box className="earnBox">
            <h6>Pool</h6>
            <p>Coming Soon!</p>

            <img src="/images/coming-soon-2.png" alt="coming soon" />
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default EarnBox
